import { IRange, ISlice } from 'components/RichTextEditor/processor/constants'
import { createRange } from 'components/RichTextEditor/processor/range'

const createFindSelectedSlice = (index: number) => (slice: ISlice) =>
  index > slice.range.start && index < slice.range.end

const getValidCollapsedSelection = (
  currentSelection: IRange,
  previousSelection: IRange,
  selectedSlice?: ISlice,
) => {
  if (!selectedSlice) {
    return currentSelection
  }
  if (currentSelection.start === selectedSlice.range.start + 1) {
    // Valid selection inside range
    return currentSelection
  }
  if (previousSelection.start === selectedSlice.range.start + 1) {
    // Selection moved within range, we have to move it outside
    return createRange(selectedSlice.range.end)
  }
  // Selection moved inside range, let's make it valid
  return createRange(selectedSlice.range.start + 1)
}

export const getValidSelection = (
  currentSelection: IRange,
  previousSelection: IRange,
  slices: ISlice[],
): IRange => {
  const startSlice = slices.find(createFindSelectedSlice(currentSelection.start))

  if (currentSelection.start === currentSelection.end) {
    return getValidCollapsedSelection(currentSelection, previousSelection, startSlice)
  }

  const endSlice = slices.find(createFindSelectedSlice(currentSelection.end))

  const start = startSlice ? startSlice.range.start : currentSelection.start
  const end = endSlice ? endSlice.range.end : currentSelection.end

  return createRange(start, end - start)
}
